import LogsErrorsBlueprint from "./index"

export default class AppWarn {
    constructor({ name = null, message = null, ...rest }) {
        // send logLevel:'warn' in the AppLog object whenever you want to log an warn level log on Datadog
        let logErrorObj = new LogsErrorsBlueprint({name, message, ...rest})
        logErrorObj.sendLogs({ logLevel: 'warn' })
    }
 }
